/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-shadow */
/* eslint-disable import/extensions */
import React, { ReactNode, useEffect, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useRouter } from 'next/router';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Container from '@material-ui/core/Container';

import clsx from 'clsx';
import Footer from '../footer/BottomFooter';
import Appbar from '../navigation/AppBar';
import BottomNavigationWrapper from '../navigation/BottomNavigation';

interface StyleProps {
  noOverflow: boolean;
}

const useStyles = makeStyles((theme) => ({
  safeAreaContainer: ({ noOverflow }: StyleProps) => (noOverflow
    ? {
      width: '100%',
      height: 'calc(100vh - 64px)',
      overflow: 'hidden',
    }
    : {
      width: '100%',
      minHeight: '100vh',
    }),
  marginTop: {
    [theme.breakpoints.up('sm')]: {
      marginTop: '64px',
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '56px',
    },
    display: 'flex',
    flexDirection: 'column',
  },
  bottomNavRoot: {
    width: '100%',
  },
  smSpacer: {
    minHeight: '60px',
  },
}));
interface Props {
  children: ReactNode;
  containerized?: boolean;
  hasFooter?: boolean;
  noOverflow?: boolean;
  disableAppbarAndFooter?: boolean;
}

const defaultProps = {
  containerized: false,
  hasFooter: false,
  noOverflow: false,
  disableAppbarAndFooter: false,
};

const RootLayout: React.FC<Props> = ({
  children,
  containerized = false,
  hasFooter = false,
  noOverflow = false,
  disableAppbarAndFooter = false,
}: Props) => {
  const classes = useStyles({ noOverflow });
  const [activeKey, setActiveKey] = useState('');
  const { pathname } = useRouter();

  useEffect(() => {
    setActiveKey(() => pathname || '');
  }, [pathname]);

  // bottom navigation
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm')); // media query for SM screens
  return (
    <>
      {/* navbar */}
      {!disableAppbarAndFooter && <Appbar activeKey={activeKey} />}

      {/* children */}
      <main
        className={clsx(
          classes.safeAreaContainer,
          !disableAppbarAndFooter ? classes.marginTop : '',
        )}
      >
        {containerized ? (
          <Container>
            <>{children}</>
          </Container>
        ) : (
          <>{children}</>
        )}
      </main>

      {sm && <div className={classes.smSpacer} />}

      {/* footer */}
      {!disableAppbarAndFooter && hasFooter && <Footer />}
      {!disableAppbarAndFooter && (
        <BottomNavigationWrapper enableBottomNavigation={sm} />
      )}
    </>
  );
};

RootLayout.defaultProps = (defaultProps as unknown) as Partial<Props>;

export default RootLayout;
